export default __webpack_public_path__ + "static/media/surveyBackground.a18cd387.jpeg";